@if (this.loading() || this.activitiesSaving() || this.notesSaving()) {
  <div class="spinner m-auto mt-40 h-32 w-32 border-8"></div>
} @else {
  @if (this.gridData.length) {
    <div class="flex justify-end space-x-2 py-3">
      <aux-button
        variant="secondary"
        label="Edit"
        data-pendo-id="map-activities-edit-button"
        icon="Pencil"
        [auxTooltip]="btnTooltip()"
        [disabled]="!!btnTooltip()"
        (clickEmit)="openMapActivitiesModal()"
      ></aux-button>
      <aux-export-excel-button
        classList="mr-1"
        [clickFN]="onExport.bind(this)"
        [spinnerSize]="7"
        pendoTag="map-activities-excel-export-button"
      />
    </div>

    <ag-grid-angular
      auxGridDynamicHeight
      class="ag-theme-aux unselectable w-full tabular-nums"
      [rowData]="gridData"
      [gridOptions]="gridOptions()"
      (gridReady)="onGridReady($event)"
    />
  } @else {
    <aux-map-activities-no-rows
      [invoice]="invoice()"
      [attributes]="attributes()"
      [budgetActivityOptions]="budgetActivityOptions()"
      [btnTooltip]="btnTooltip()"
      [lastUpdated]="lastUpdated()"
      [noteId]="noteId"
      [noteMessage]="noteControl.value || ''"
      (saveActivities)="saveActivities($event)"
    />
  }

  @if (this.noteControl.value) {
    <div class="mt-[30px] w-[500px]">
      <div class="flex items-center justify-between space-x-1">
        <span class="mr-1">Comments</span>

        <span class="text-aux-gray-dark-2">{{ this.noteControl.value.length || 0 }} / 1000</span>
      </div>

      <aux-input
        placeholder="Enter comments here..."
        [textArea]="true"
        [rows]="5"
        [readonly]="true"
        resize="none"
        class="textarea-input mt-1"
        [maxlength]="1000"
        [formControl]="noteControl"
      />
    </div>
  }

  @if (lastUpdatedList.length && (this.noteControl.value || this.gridData.length)) {
    <div class="mt-2">Last Updated: {{ lastUpdated() }}</div>
  }
}
